import { clsx } from 'clsx';
import { FormattedElapsedTime } from './FormattedElapsedTime';
import { RoundIcon } from '../../icon/RoundIcon';

interface LoadingPageSpinnerProps {
  title: string;
  subtitle: string;
  className?: string;
  showElapsedTime?: boolean;
}

export function LoadingPageSpinner({
  title,
  subtitle,
  showElapsedTime,
  className
}: LoadingPageSpinnerProps) {
  return (
    <div className={clsx('center-flex-col justify-center', className)}>
      <RoundIcon
        iconName='testing'
        containerBg='primary-faded'
        className='mb-3'
        dataId='spinner'
        isIconColorWhite={false}
        iconClasses='text-primary'
        showSpinningAnimation
      />

      <div className='text-subheading-2'>
        {title}&nbsp;
        {showElapsedTime ? (
          <span className='text-primary'>
            (<FormattedElapsedTime />)
          </span>
        ) : null}
      </div>

      <div className='text-secondary mt-1 text-center' style={{ maxWidth: '500px' }}>
        {subtitle}
      </div>
    </div>
  );
}
